import React from "react";
import OrdersPage from "./OrdersPage";

const Order = () => {
  return (
    <div>
      <OrdersPage />
    </div>
  );
};

export default Order;
